import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=c3680028&scoped=true&lang=html&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3680028",
  null
  
)

export default component.exports